import { View } from "react-native";

export default function Messaging() {
  return <View></View>;
}
